import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { DesignProvider } from "./shared/design/DesignProvider";

import "./styles.css";
import "./shared/theme/themes.css";
import "./shared/design/spatial-flow.css";
import "./shared/design/soft-neumorphism.css";
import "./shared/design/liquid-glass.css";
import "./shared/design/scrolling.css";
import "./features/event-circle/EventCirclePage.css";

createRoot(
  document.getElementById("root")!,
).render(
  <StrictMode>
    <ThemeProvider>
      <DesignProvider>
        <App />
      </DesignProvider>
    </ThemeProvider>
  </StrictMode>,
);